import { render, staticRenderFns } from "./ReservationCalendarPage.vue?vue&type=template&id=0454b2d4&"
import script from "./ReservationCalendarPage.vue?vue&type=script&lang=js&"
export * from "./ReservationCalendarPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports